import axios from 'axios'
import SettingsState from '../store/Settings/SettingsState'
import config from './../config'

export const settingsApi = {
    getSettings: async () => {
        return await axios.get<SettingsState>(`${config.apiUrl}/settings`)
    }
}
